"use client";

import { useEffect } from "react";

import {
  getSessionStorageItem,
  removeSession,
  setSessionStorageItem,
} from "@/utils/common/sessionStorageItemHelper/sessionStorageItemUtils";
import dayjs from "@/utils/dayjs";
import { SessionStorageItemEnum } from "@/utils/enums/SessionStorageItemEnum";

const AutoRefreshWrapper = () => {
  useEffect(() => {
    const { STORAGE_KEY } = SessionStorageItemEnum;

    const getStoredTimestamp = () => {
      const stored = getSessionStorageItem(STORAGE_KEY);
      return stored ? dayjs(parseInt(stored, 10)) : null;
    };

    const setRefreshTimestamp = () => {
      const expireTime = dayjs().add(60, "minute").valueOf();

      setSessionStorageItem(STORAGE_KEY, expireTime.toString());
      return expireTime;
    };

    const checkAndRefresh = () => {
      const storedTimestamp = getStoredTimestamp();
      const now = dayjs();

      if (!storedTimestamp || now.isAfter(storedTimestamp)) {
        removeSession(STORAGE_KEY);

        // Get the current URL and remove any existing 't' parameters
        let currentUrl = window.location.href;
        currentUrl = currentUrl.replace(/([?&])t=\d+/g, ""); // Remove existing 't' query params

        // Append the new timestamp
        window.location.href = currentUrl;
      } else {
        const remainingTime = storedTimestamp.diff(now);
        setTimeout(checkAndRefresh, remainingTime);
      }
    };

    // Reset timestamp when navigating to a new page
    const newExpireTime = setRefreshTimestamp();
    const timeout = setTimeout(
      checkAndRefresh,
      dayjs(newExpireTime).diff(dayjs()),
    );

    return () => clearTimeout(timeout);
  }, []);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return null;
};

export default AutoRefreshWrapper;
